import React from "react";
import {Button, Carousel, Col, Row, Spin} from "antd";
import { useMediaQuery } from 'react-responsive'
import {RightOutlined, SyncOutlined} from "@ant-design/icons";
import useFrontpage from "hooks/frontpage";
import data from "./data";

const Banner : React.FC = () => {

    const [isLoading, bannerURL] = useFrontpage();

    const isTabletDown  = useMediaQuery({  query : "(max-width: 767px)"});
    const isPhoneDown   = useMediaQuery({  query : "(max-width: 480px)"});

    return (
        <Spin spinning={isLoading} indicator={<SyncOutlined style={{ fontSize: 24 }} spin />}>
            <section className={"main-banner"}>
               <div className={"public-container"}>
                   <Row gutter={[50, 30]} className={"describe"}>
                       <Col md={{push : 13, span : 11}}  sm={24} xs={24}>
                           <div className={"sub-banner"}>
                                <img src={bannerURL} alt={" "} />
                           </div>
                       </Col>
                       <Col md={{pull : 11, span : 13}} sm={24} xs={24} className={"carousel-section"}>
                           <Carousel
                               dotPosition={ isPhoneDown || isTabletDown ? "bottom" : "left"}
                               dots={{className : "cr-dots"}}
                               autoplay={true}
                               autoplaySpeed={3000}
                           >
                               {
                                   data.banner.id.map((item, x ) => (
                                       <div key={item.title} className={`section-heading child-${x}`}>
                                           <h1 className={"title"}>{item.title}</h1>
                                           <p className={"subtitle"}>{item.subTitle}</p>
                                           <Button
                                               href={"https://dashboard-new-etc.web.app/daftar"}
                                               type={"primary"}
                                               size={"large"}
                                           >
                                               {item.buttonText} <RightOutlined />
                                           </Button>
                                       </div>
                                   ))
                               }
                           </Carousel>
                       </Col>
                   </Row>
               </div>
            </section>
        </Spin>
    )
}

export default React.memo(Banner);